import React, { Component } from 'react';
import { Container, Col, Row } from 'reactstrap'

class Login extends Component {
  render() {
    return (
      <Container fluid className="p-0 h-100">
        <Row className="no-gutters h-100 full-height">
          <Col lg={4} className="d-lg-flex bg" style={{backgroundImage:'url("login-1.jpg")'}}>
          </Col>
          <Col lg={8} className="bg-white">
            <Container className="h-100">
              <Row noGutters className="h-100 align-items-center">
                <Col md={8} lg={7} xl={6} className="mx-auto">
                  <h2>Đăng nhập</h2>
                  <p className="m-b-30">Đăng nhập bằng tài khoản nhân viên / giảng viên do nhà trường cung cấp.</p>
                  <a href="https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=343ed40a-80a3-43e8-84a8-d7f9c18fcf0a&response_type=token&redirect_uri=http://localhost:3000/auth/callback&scope=api://343ed40a-80a3-43e8-84a8-d7f9c18fcf0a/User.read offline_access&response_mode=fragment"
                  className="btn btn-info btn-block mt-4">Đăng nhập Office 365</a>
                </Col>
              </Row>

            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/auth/Login.js